"use client";
import { jsx as i, jsxs as C } from "react/jsx-runtime";
import { createElement as _ } from "react";
import { css as e } from "@emotion/react";
import a from "@emotion/styled";
import { ellipsis as G } from "../../common/styles/mixins/ellipsis.js";
import T from "../icon/Icon.js";
import { SELECT_LIST_SIZES as H, SELECT_ITEM_SIZES as x } from "./selectCommonTypes.js";
import w from "../spacer/Spacer.js";
import { COLORS as $ } from "../../tokens/colors/Colors.js";
import { FONT_SIZES as v } from "../../tokens/font-sizes/FontSizes.js";
import { FONT_WEIGHTS as N } from "../../tokens/font-weights/FontWeights.js";
import { SHADOWS as z } from "../../tokens/shadows/Shadows.js";
import { SPACINGS as m } from "../../tokens/spacings/Spacings.js";
const O = ({
  allItems: o,
  getItemProps: r,
  getMenuProps: c,
  highlightedIndex: l,
  isOpen: h,
  items: S,
  listHeight: g,
  listWidth: y,
  selectedItems: t,
  size: s
}) => /* @__PURE__ */ i(
  k,
  {
    ...c(),
    isOpen: h,
    listHeight: g,
    listWidth: y,
    stParent: !0,
    children: h && S.map((n) => {
      var L;
      const d = n.items != null;
      let f;
      if (d)
        return /* @__PURE__ */ C("li", { children: [
          /* @__PURE__ */ i(Z, { size: s, children: n.label }),
          /* @__PURE__ */ i(k, { children: (L = n.items) == null ? void 0 : L.map((u) => {
            const p = o.findIndex((b) => b.value === u.value);
            return f = t == null ? void 0 : t.some((b) => b.value === u.value), E({
              getItemProps: r,
              highlightedIndex: l,
              index: p,
              inGroup: !0,
              isSelected: f,
              item: u,
              size: s
            });
          }) })
        ] }, n.label);
      {
        const u = o.findIndex((p) => p.value === n.value);
        return f = t == null ? void 0 : t.some((p) => p.value === n.value), E({
          getItemProps: r,
          highlightedIndex: l,
          index: u,
          isSelected: f,
          item: n,
          size: s
        });
      }
    })
  }
);
O.displayName = "SelectList";
const E = ({
  getItemProps: o,
  highlightedIndex: r,
  inGroup: c,
  index: l,
  isSelected: h,
  item: S,
  size: g
}) => {
  const { value: y, disabled: t, feShortLabel: s, label: n, feIcon: d } = S, f = o({ item: S, index: l }).onClick;
  return /* @__PURE__ */ _(
    j,
    {
      ...o({ item: S, index: l }),
      onTouchStart: f,
      key: `${y}${l}`,
      size: g,
      stDisabled: t,
      stHighlighted: r === l
    },
    h ? /* @__PURE__ */ i(D, { feIcon: "check" }) : /* @__PURE__ */ i(F, { feSpacing: "md", feHorizontal: !0 }),
    c && /* @__PURE__ */ i(w, { feHorizontal: !0, feSpacing: "sm" }),
    /* @__PURE__ */ i(A, { children: n }),
    s && !d && /* @__PURE__ */ i(I, { children: s }),
    !s && d && /* @__PURE__ */ i(W, { feIcon: d })
  );
}, k = a.ul(
  ({ isOpen: o, listHeight: r, listWidth: c, stParent: l }) => e`
		display: flex;
		flex-direction: column;

		${l && e`
			background-color: ${$.white};
			box-shadow: ${o ? z.lg : "none"};
			opacity: ${o ? 1 : 0};
			padding: ${H.padding};
			width: ${c}px;

			${r && e`
				max-height: ${r}px;
				overflow-y: auto;
			`}
		`}
	`
), Z = a.div(
  ({ size: o }) => e`
		align-items: center;
		display: flex;
		font-weight: ${N.bold};
		height: ${x.md};
		margin-left: ${m.xs};

		${o === "sm" && e`
			font-size: ${v.sm};
			height: ${x.sm};
		`}
	`
), j = a.li(
  ({ stDisabled: o, size: r, stHighlighted: c }) => e`
		align-items: center;
		background-color: ${c ? $.primary200 : $.white};
		cursor: pointer;
		display: flex;
		flex-shrink: 0;
		height: ${x.md};
		padding-inline-end: ${m.xs};

		${r === "sm" && e`
			font-size: ${v.sm};
			height: ${x.sm};
		`}

		${o && e`
			color: ${$.gray500};
			cursor: default;
		`}
	`
), A = a.div`
	${G()};
	max-width: 100%;
`, D = a(T)`
	margin-inline: ${m.xxs} ${m.xs};
`, F = a(w)`
	margin-inline: ${m.xxs} ${m.xs};
`, I = a.span`
	color: ${$.gray500};
	font-size: ${v.sm};
	margin-left: auto;
`, W = a(T)`
	color: inherit;
	margin-left: auto;
`;
export {
  O as default
};
